module.exports = __webpack_public_path__ + "img/directional-selected.7cb51ba6.png";